import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import ErrorBoundary from './ErrorBoundary';
import DeckViewControls from './DeckViewControls';
import DeckActions from './DeckActions';
import { VIEW_MODES } from '../../helpers/viewModeConstants';

const DeckControlsBar = ({
  tableData,
  viewMode,
  onViewModeChange,
  cardLoading,
  deckPrefs,
  onGroupByChange,
  sortColumn,
  allColumns,
  selectedCount,
  onBulkDelete,
  collection,
  canEdit,
  spacing,
  colors,
}) => {
  if (tableData.length === 0) return null;

  return (
    <div style={{
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'stretch' : 'center',
      justifyContent: isMobile ? 'flex-start' : 'space-between',
      gap: spacing.controlsGap,
      marginBottom: spacing.controlsMarginBottom,
    }}>
      <ErrorBoundary>
        <DeckViewControls
          tableData={tableData}
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
          cardLoading={cardLoading}
          deckPrefs={deckPrefs}
          onGroupByChange={onGroupByChange}
          sortColumn={sortColumn}
          allColumns={allColumns}
          COLORS={colors}
        />
      </ErrorBoundary>
      {collection?.type === 'DECK' && canEdit && (
        <div style={{ display: 'flex', justifyContent: isMobile ? 'space-between' : 'flex-end', width: isMobile ? '100%' : 'auto' }}>
          <DeckActions
            selectedCount={selectedCount}
            onBulkDelete={onBulkDelete}
            spacing={spacing}
            colors={colors}
          />
        </div>
      )}
    </div>
  );
};

DeckControlsBar.propTypes = {
  tableData: PropTypes.array.isRequired,
  viewMode: PropTypes.oneOf([VIEW_MODES.TABLE, VIEW_MODES.VISUAL]).isRequired,
  onViewModeChange: PropTypes.func.isRequired,
  cardLoading: PropTypes.bool,
  deckPrefs: PropTypes.object.isRequired,
  onGroupByChange: PropTypes.func.isRequired,
  sortColumn: PropTypes.string,
  allColumns: PropTypes.array.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onBulkDelete: PropTypes.func.isRequired,
  collection: PropTypes.object,
  canEdit: PropTypes.bool.isRequired,
  spacing: PropTypes.object.isRequired,
  colors: PropTypes.object.isRequired,
};

DeckControlsBar.defaultProps = {
  cardLoading: false,
  sortColumn: null,
  collection: null,
};

export default DeckControlsBar;
